// eslint-disable-next-line import/prefer-default-export
export const INPUT_ERROR = {
  BUSINESS_IDENTIFIER: 'INPUT_ERROR_BUSINESS_IDENTIFIER',
  ACCOUNT_NUMBER: 'INPUT_ERROR_ACCOUNT_NUMBER',
  LENGTH_PHONE: 'INPUT_ERROR_LENGTH_PHONE',
};
